import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=e470d11e&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e470d11e')) {
      api.createRecord('e470d11e', component.options)
    } else {
      api.reload('e470d11e', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=e470d11e&", function () {
      api.rerender('e470d11e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sJRURjo9hg48/JS/cancellationPolicy.vue"
export default component.exports